import Button from "components/button"
import { useSession } from "contexts/session-context"
import { useTrivia } from "contexts/trivia-context"
import { Link, useRouteMatch } from "react-router-dom"
import textServices from "services/text-services"
import { useContext, useEffect } from "react"
import { LoaderContext } from "contexts/loader-context"
import TriviaChallenge from "../trivia/trivia"
import { DescriptionTriviaQr, ImgTriviaQr, TitleTriviaQr } from "./styles/styled.components"

function TriviaQr() {

  const [{ user, data }] = useSession()
  const [{ trivias }, { getTrivias }] = useTrivia()
  const { setLoad } = useContext(LoaderContext)
  const route = useRouteMatch<{ id: string }>()
  const handleClick = () => {
    localStorage.setItem('url_redirect', `/trivia/qr/${route.params.id}`)
  }
  const TitleTriviaLate = textServices?.findByText('trivias/triviaQr/late/title', <>¡UPS!<br />YA ES TARDE</>)

  const handleTrivia = async () => {
    try {
      if (!trivias) {
        setLoad(true)
        await getTrivias()
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoad(false)
    }
  }

  useEffect(() => {
    handleTrivia()
  }, [trivias, data])

  if (!user) {
    return (
      <div className="py-7 px-7 flex-1 w-full flex flex-col gap-6">
        <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 text-center">
          <TitleTriviaQr>{textServices?.findByText('trivias/triviaQr/register/title', <>CONTESTA<br />Y GANA</>)}</TitleTriviaQr>
          <DescriptionTriviaQr className="flex flex-col items-center justify-center gap-5">{textServices?.findByText('trivias/triviaQr/register/description', <>¿Ya tienes tu ID?<br />SI NO LO TIENES CÓRRELE A REGISTRARTE PARA PODER PARTICIPAR</>)}</DescriptionTriviaQr>
        </div>
        <ImgTriviaQr src={`${AZURE_BASE_URL}/trivia-qr-card-id.svg`} alt="" />
        <Link to={'/start'} onClick={handleClick}>
          <Button>{textServices?.findByText('trivias/triviaQr/register/button', 'COMENCEMOS')}</Button>
        </Link>
      </div>
    )
  }

  if (trivias && !trivias?.some(({ id }) => id === parseInt(route.params.id, 10))) {
    return (
      <div className="py-7 px-7 flex-1 w-full flex flex-col">
        <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 text-center">
          <TitleTriviaQr>{typeof TitleTriviaLate === 'function' ? TitleTriviaLate(user) : TitleTriviaLate}</TitleTriviaQr>
          <DescriptionTriviaQr className="flex flex-col items-center justify-center gap-5">{textServices?.findByText('trivias/triviaQr/late/description', <>Lamentablemente esta trivia ya no está disponible. Busca nuevo QR dentro de las otras dinámicas que tenemos para ti para contestar una trivia nueva</>)}</DescriptionTriviaQr>
        </div>
        <Link to='/trivias'>
          <Button>VER MÁS</Button>
        </Link>
      </div>
    )
  }

  return (
    <TriviaChallenge />
  )
}

export default TriviaQr